export default __webpack_public_path__ + "static/media/img-quality-roast.1d8a7743.png";